import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  computed,
  input
} from '@angular/core';
import { FeedbackMessage } from './form-field.models';
import { FEEDBACK_MESSAGE_HOST } from './form-field.constants';

@Component({
  selector: '[feedbackMessage]',
  standalone: false,
  host: FEEDBACK_MESSAGE_HOST,
  template: ` <span class="feedback-message__icon">
      @if (this.type() === 'error') {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="13.966"
          height="12.221"
          viewBox="0 0 13.966 12.221"
        >
          <g id="triangle-exclamation" transform="translate(-0.035 -32)">
            <path
              id="Tracé_1861"
              data-name="Tracé 1861"
              d="M225.418,148.8a.653.653,0,0,0,.655-.655v-3.492a.65.65,0,0,0-.63-.655.694.694,0,0,0-.679.655v3.492A.655.655,0,0,0,225.418,148.8Zm0,.9a.858.858,0,1,0,.858.858A.858.858,0,0,0,225.418,149.7Z"
              transform="translate(-218.401 -108.945)"
              fill="currentColor"
            />
            <path
              id="Tracé_1862"
              data-name="Tracé 1862"
              d="M13.845,42.5,8.026,32.573a1.175,1.175,0,0,0-2.018,0L.192,42.5A1.146,1.146,0,0,0,1.2,44.221H12.837A1.148,1.148,0,0,0,13.845,42.5ZM6.362,35.71a.655.655,0,1,1,1.309,0V39.2a.65.65,0,0,1-.63.655.692.692,0,0,1-.679-.655Zm.655,6.765a.858.858,0,1,1,.858-.858A.858.858,0,0,1,7.017,42.475Z"
              transform="translate(0)"
              fill="currentColor"
              opacity="0.4"
            />
          </g>
        </svg>
      } @else {
        <svg
          id="circle-info"
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="15"
          viewBox="0 0 15 15"
        >
          <path
            id="Tracé_1859"
            data-name="Tracé 1859"
            d="M193.875,129.875a.938.938,0,1,0-.937-.937A.938.938,0,0,0,193.875,129.875Zm1.172,4.219h-.469v-2.578a.7.7,0,0,0-.7-.7h-.937a.7.7,0,0,0,0,1.406h.234v1.875H192.7a.7.7,0,0,0,0,1.406h2.344a.7.7,0,0,0,0-1.406Z"
            transform="translate(-186.375 -124.25)"
            fill="currentColor"
          />
          <path
            id="Tracé_1860"
            data-name="Tracé 1860"
            d="M7.5,0A7.5,7.5,0,1,0,15,7.5,7.5,7.5,0,0,0,7.5,0Zm0,3.75a.937.937,0,1,1-.938.937A.938.938,0,0,1,7.5,3.75Zm1.172,7.5H6.328a.7.7,0,0,1,0-1.406H6.8V7.969H6.563a.7.7,0,0,1,0-1.406H7.5a.7.7,0,0,1,.7.7V9.844h.469a.7.7,0,0,1,0,1.406Z"
            fill="currentColor"
            opacity="0.4"
          />
        </svg>
      }
    </span>
    <span class="feedback-message__text"><ng-content></ng-content></span>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class FeedbackMessageComponent {
  type = input<FeedbackMessage>('hint');

  protected classList = computed(
    () => `feedback-message feedback-message--${this.type()}`
  );
}
